import React from 'react';

import { colorsPalette } from '../../theme';

const ViewIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      color={color}
    >
      <path
        d="M16.3877 6.9645V5.67878C16.3877 5.56092 16.2913 5.4645 16.1734 5.4645H5.88772C5.76986 5.4645 5.67343 5.56092 5.67343 5.67878V6.9645C5.67343 7.08235 5.76986 7.17878 5.88772 7.17878H16.1734C16.2913 7.17878 16.3877 7.08235 16.3877 6.9645ZM5.88772 9.32164C5.76986 9.32164 5.67343 9.41807 5.67343 9.53592V10.8216C5.67343 10.9395 5.76986 11.0359 5.88772 11.0359H10.8163C10.9341 11.0359 11.0306 10.9395 11.0306 10.8216V9.53592C11.0306 9.41807 10.9341 9.32164 10.8163 9.32164H5.88772ZM9.74486 21.4288H3.53058V2.57164H18.5306V11.7859C18.5306 11.9038 18.627 12.0002 18.7449 12.0002H20.2449C20.3627 12.0002 20.4591 11.9038 20.4591 11.7859V1.50021C20.4591 1.0261 20.0761 0.643066 19.602 0.643066H2.45915C1.98504 0.643066 1.60201 1.0261 1.60201 1.50021V22.5002C1.60201 22.9743 1.98504 23.3574 2.45915 23.3574H9.74486C9.86272 23.3574 9.95915 23.2609 9.95915 23.1431V21.6431C9.95915 21.5252 9.86272 21.4288 9.74486 21.4288Z"
        fill="currentColor"
      />
      <path
        d="M10.7838 17.4677C10.7067 17.6343 10.6667 17.8161 10.6667 18.0002C10.6667 18.1842 10.7067 18.366 10.7838 18.5327C12.0621 21.2624 14.0375 22.6668 16.6665 22.6668C19.2955 22.6668 21.2708 21.2595 22.5492 18.5327C22.7054 18.1962 22.7053 17.8071 22.5521 17.4706L22.5463 17.4647C21.2708 14.7379 19.2955 13.3335 16.6665 13.3335C14.0375 13.3335 12.0621 14.7408 10.7838 17.4677ZM16.6665 15.206C18.4625 15.206 19.7727 16.0838 20.7473 18.0002C19.7756 19.9166 18.4625 20.7943 16.6665 20.7943C14.8704 20.7943 13.5603 19.9166 12.5856 18.0002C13.5603 16.0838 14.8704 15.206 16.6665 15.206Z"
        fill="currentColor"
      />
      <path
        d="M15.0613 18.0059C15.0613 18.4404 15.2319 18.8572 15.5357 19.1645C15.8394 19.4717 16.2514 19.6444 16.6809 19.6444C17.1105 19.6444 17.5224 19.4717 17.8262 19.1645C18.1299 18.8572 18.3005 18.4404 18.3005 18.0059C18.3005 17.5714 18.1299 17.1546 17.8262 16.8473C17.5224 16.5401 17.1105 16.3674 16.6809 16.3674C16.2514 16.3674 15.8394 16.5401 15.5357 16.8473C15.2319 17.1546 15.0613 17.5714 15.0613 18.0059Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ViewIcon;
